// @flow
import React, { PureComponent } from 'react';
import type { Element } from 'react';
import { Link } from 'react-router-dom';
import styles from 'components/ErrorBox.scss';
import classNames from 'classnames';

/**
 * <ErrorBox /> component.
 */
class ErrorBox extends PureComponent<*, *> {
  render(): Element<*> {
    const { type } = this.props;

    return (
      <div
        className={classNames(
          styles.errorBox,
          type === 'noResults' ? styles.noResults : null
        )}
      >
        {type === 500 && (
          <p>
            The site is having some technical issues. Please refresh the page or
            try again later.
          </p>
        )}
        {type === 404 && (
          <div>
            <h1>Sorry - page not found</h1>
            <p>The link you followed does not exist.</p>
            <p>
              Start a new used car search <Link to="/used-cars">here</Link>
            </p>
          </div>
        )}
        {type === 'noResults' && (
          <p>
            There are no results for this search. Try removing some filters from
            the Active panel.
          </p>
        )}
      </div>
    );
  }
}

export default ErrorBox;



// WEBPACK FOOTER //
// ./src/Common/ErrorBox/index.js